import { createContext, useState } from "react";

export const TopBarContext = createContext();

export const TopBarProvider = ({ children }) => {
	const [TopBarContent, setTopBarContent] = useState(null);

	return <TopBarContext.Provider value={{ TopBarContent, setTopBarContent }}>{children}</TopBarContext.Provider>;
};
